module.exports = __webpack_public_path__ + "img/1572400261.f42ad0e0.jpg";